import { AccountType } from '@/data/usecases/account/account-type'
import { AccountModel } from '@/domain/models/account/account-model'
import { DocumentType } from '@/domain/models/document/document-type'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient } from 'launchdarkly-react-client-sdk'

export const showUpgradeRequestButton = (
  ldClient: LDClient | undefined,
  account: AccountModel
): boolean => {
  if (
    FeatureFlag.Key.UPGRADE_REQUEST.isEnabled(ldClient) &&
    account.passPlan &&
    (account.passPlan.id as number) < 5 &&
    AccountType.Enum.COLLABORATOR.is(account) &&
    account.company.allowUpgrade &&
    DocumentType.Enum.CPF.is(account.document)
  ) {
    return true
  }
  return false
}
